const BASE_URL = process.env.REACT_APP_SITE_BASE_URL

export const HOW_IT_WORKS_URL = `${BASE_URL}/how-it-works/`
export const WHY_COOKUNITY_URL = `${BASE_URL}/static/whyCookunity/`
export const TERMS_OF_USE_URL = `${BASE_URL}/terms/`
export const PRIVACY_POLICY_URL = `${BASE_URL}/privacy-policy/`
export const BLOG_URL = 'https://www.cookunity.com/blog/'
export const GIFTCARD_URL = `${BASE_URL}/giftcard/`
export const BECOME_CHEF_URL = `${BASE_URL}/become-a-chef/`
export const DELIVERY_MAP_URL = `${BASE_URL}/delivery-map/`
export const RECYCLE_URL = `${BASE_URL}/en/recycle/`
export const COOKUNITY_ZENDESK = 'https://cookunitysupport.zendesk.com'
export const COOKUNITY_FACEBOOK = 'https://www.facebook.com/Cookunity.us'
export const COOKUNITY_INSTAGRAM = 'https://instagram.com/cookunity'
export const COOKUNITY_TWITTER = 'https://twitter.com/Cookunity'
export const MAILTO_COOKUNITY = 'mailto:info@cookunity.com'
export const COOKUNITY_APPSTORE =
  'https://itunes.apple.com/us/app/cookunity/id1103061273?mt=8'



// WEBPACK FOOTER //
// ./src/utils/constants.js